import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "../../lib/api";
import { EASE } from "../../components/site/Motion";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-ink px-5">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="w-full max-w-sm border border-white/10 bg-card p-8"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3">
          <img src="/assets/logo-wordmark.webp" alt="SWAPA™" className="h-5 w-auto" />
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">CMS</span>
        </div>
        <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Accesso riservato</p>
        <input
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="mt-8 w-full border border-white/15 bg-ink px-4 py-3.5 text-sm text-white placeholder:text-zinc-600 focus:border-swapa-yellow focus:outline-none"
        />
        <input
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="mt-4 w-full border border-white/15 bg-ink px-4 py-3.5 text-sm text-white placeholder:text-zinc-600 focus:border-swapa-yellow focus:outline-none"
        />
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="mt-6 w-full bg-swapa-yellow py-3.5 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-black disabled:opacity-50"
        >
          {loading ? "Accesso…" : "Accedi"}
        </button>
      </motion.form>
    </div>
  );
}
